// extracted by mini-css-extract-plugin
module.exports = {"container":"_2KvRA","left":"_2yYIU","right":"_21wk3"};